import React, { useState, forwardRef, useEffect, useRef, useMemo, useCallback } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faFilter } from '@fortawesome/free-solid-svg-icons';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import { VehiculosService, GruposService, GeocercaService, AlertaService, } from '../../../../services/apiService';
import { useGoogleMaps } from '../../../../providers/GoogleMapsProvider';
import ReactGoogleAutocomplete from 'react-google-autocomplete';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { sortBy } from "underscore";

import { MultiSelect } from 'primereact/multiselect';
import '../../../../styles/global.css'
import "primereact/resources/themes/lara-light-blue/theme.css";

import { locale as primeLocale, addLocale } from 'primereact/api'
import { useFiltrosStore } from "../../../../lib/store/filtros.store";
import { mapStore } from '../../../../lib/store/map_store';
import { AccionBitacora, generarObservacion, guardarBitacora } from '../../../../utils/bitacora';
import { createRenderCustomHeader } from '../../../../components/datepicker/CustomDatePickerHeader';
import { handleStartDateChange, handleEndDateChange } from '../../../../utils/datePickerUtils';
import '../../../../styles/datepicker.css'

// 📌 Registrar la localización en español para DatePicker 
registerLocale('es', es);
setDefaultLocale('es'); //  

const PuntoCercanoFiltros = ({ onGenerateReport, miUbicacion, actualizarMiUbicacion, distancia, setDistancia, imprimir }) => {
    const store = mapStore();
    const { isLoaded } = useGoogleMaps(); // ✅ Esperar a que Google Maps esté listo

    const [grupos, setGrupos] = useState([]);
    const [selectedGrupo, setSelectedGrupo] = useState(null);

    const [cargandoTipoAlertas, setCargandoTipoAlertas] = useState(false);
    const [tipoAlertas, setTipoAlertas] = useState([]);

    const [geocercas, setGeocercas] = useState([]);
    const vehiculos = useFiltrosStore((state) => state.vehiculos)
    const setVehiculos = useFiltrosStore((state) => state.setVehiculos)
    const vehiculosFiltrado = useFiltrosStore((state) => state.vehiculosFiltrado)
    const setVehiculosFiltrados = useFiltrosStore((state) => state.setVehiculosFiltrados)

    //const [selectedVehiculos, setSelectedVehiculos] = useState([]);
    //const [selectedGrupos, setSelectedGrupos] = useState([]);
    const [open, setOpen] = useState(true);
    //const [vehiculos, setVehiculos] = useState([]);
    //const [vehiculosFiltrados, setVehiculosFiltrados] = useState([]);
    //const [grupos, setGrupos] = useState([]);

    const [selectedVehicle, setSelectedVehicle] = useState([]);

    const [btnFiltroActivo, setBtnActiveFilter] = useState(false);

    // Establecer valores iniciales para las fechas
    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0); // Inicio del día (00:00:00)
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59); // Fin del día (23:59:59)

    // Inicializar fechas con el día actual
    const [startDate, setStartDate] = useState(startOfDay);
    const [endDate, setEndDate] = useState(endOfDay);
    const [dateRangeWarning, setDateRangeWarning] = useState("");
    const [dateRangeInvalid, setDateRangeInvalid] = useState(false);
    // Validar rango de fechas: máximo 1 día
    useEffect(() => {
        if (!startDate || !endDate) return;
        const diffMs = endDate - startDate;
        const diffDays = diffMs / (1000 * 60 * 60 * 24);
        if (diffDays > 30) {
            setDateRangeWarning("El rango máximo permitido es de 30 días.");
            setDateRangeInvalid(true);
            // import('sweetalert2').then(Swal => {
            //     Swal.default.fire({
            //         icon: 'warning',
            //         title: 'Rango de fechas inválido',
            //         text: 'El rango máximo permitido es de 1 día.',
            //     });
            // });
        } else {
            setDateRangeWarning("");
            setDateRangeInvalid(false);
        }
    }, [startDate, endDate]);



    // 🚗 Cargar Vehículos
    const loadVehiculos = async () => {
        try {
            const response = await VehiculosService.getVehiculos();
            if (response && response.statusCode === 200) {

                const _vehiculos = sortBy(response.data, function (i) { return (i.alias ?? "").trim().toUpperCase() })

                const vehiculosData = _vehiculos.map(vehiculo => {
                    const randomColor = Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
                    return ({
                        value: vehiculo.uid_vehiculo,
                        label: `${vehiculo.no_economico ?? ""} / ${vehiculo.alias ?? ""}`,
                        uid_grupo: vehiculo.uid_grupo,
                        no_economico: vehiculo.no_economico,
                        alias: `${vehiculo.alias}`,
                        color: randomColor
                    })
                });
                setVehiculos(vehiculosData);
                setVehiculosFiltrados([])
            }
        } catch (error) {
            console.error("Error cargando vehículos:", error);
        }
    };

    // 📌 Cargar Geocercas
    const loadGeocercas = async () => {
        try {
            const response = await GeocercaService.getGeocercas();
            if (response && response.statusCode === 200) {

                const _geocercas = sortBy(response.data, function (i) { return i.nombre.trim().toUpperCase() })

                setGeocercas(_geocercas);
            }
        } catch (err) {
            console.error("Error cargando geocercas:", err);
        }
    };

    // 👥 Cargar Grupos
    const loadGrupos = async () => {
        try {
            const response = await GruposService.getGrupos();
            if (response && response.statusCode === 200) {

                const _grupos = sortBy(response.data, 'nombre')

                const gruposData = _grupos.map((grupo) => ({
                    value: grupo.uid_grupo,
                    label: `${grupo.nombre}`,
                    uid_grupo: grupo.uid_grupo
                }));

                //setSelectedGrupo(gruposData)
                setGrupos(gruposData);
            }
        } catch (error) {
            console.error("Error cargando los grupos:", error);
        }
    };

    // 👥 Cargar tipo alertas
    const cargarTipoAlertas = async () => {
        if (cargandoTipoAlertas)
            return;
        setCargandoTipoAlertas(true);
        try {
            const response = await AlertaService.getTipoAlertaQuro();
            if (response && response.statusCode === 200) {
                const alertasIdList = (response.data.sort((a, b) => a.orden - b.orden)).map(item => { return item.tipo_alerta });
                setTipoAlertas(alertasIdList);
            }
        } catch (error) {
            console.error("Error cargando los tipo de alertas:", error);
        } finally {
            setCargandoTipoAlertas(false);
        }
    };

    useEffect(() => {
        loadGrupos();
        loadVehiculos();
        cargarTipoAlertas();
        loadGeocercas();

        if (!navigator.geolocation) {
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                actualizarMiUbicacion({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                });
            },
            () => { }
        );
    }, []);

    useEffect(() => {
        if (selectedVehicle.length > 0 && distancia > 0 && miUbicacion.lat) {
            setBtnActiveFilter(true)
        } else {

            setBtnActiveFilter(false)
        }
    }, [selectedVehicle, distancia, miUbicacion])

    useEffect(() => {

        setVehiculosFiltrados(selectedGrupo || [])
    }, [selectedGrupo]);

    // Al seleccionar los filtros, los pasamos al contenedor padre (index)
    const handleGenerate = () => {
        setOpen(false);
        // 🔹 Ajustar fechas a la zona horaria local para que coincidan con la selección del usuario
        /*const offset = new Date().getTimezoneOffset() * 60000; // Obtener offset en milisegundos
        const fecha_inicio = new Date(startDate.getTime() - offset).toISOString(); // Ajustar a UTC
        const fecha_fin = new Date(endDate.getTime() - offset).toISOString(); // Ajustar a UTC*/
        generarBitacoraReporte(AccionBitacora.Generar);
        const _fechaInicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
        const _fechaFin = dayjs(endDate.getTime()).format("YYYY-MM-DDTHH:mm:ss")

        const vs = vehiculos.filter(w => selectedVehicle.includes(w.value));
        onGenerateReport({
            fecha_inicio: _fechaInicio,
            fecha_fin: _fechaFin,
            uids_vehiculos: vs && vs.length > 0 ? vs : [],
            uid_cliente: "",
            uid_chofere: "",
            uid_geocerca: "",
            latitud: miUbicacion.lat,
            longitud: miUbicacion.lng,
            distancia: distancia,
            tipo_filtro: 0,
            geocercas: geocercas,
            ids_tipo_alerta: tipoAlertas
        });
    };

    useEffect(() => {
        guardarBitacora({ categoria: 'Reporte Radar', observacion: 'Radar', tipoAccion: AccionBitacora.EntrarReporte });
        window.guardarBitacoraPrint = () => {
            generarBitacoraReporte(AccionBitacora.Imprimir);
        };
        window.guardarBitacoraExport = () => {
            generarBitacoraReporte(AccionBitacora.Exportar);
        };
    }, []);
    const filtrosGenerarRef = useRef();
    const generarBitacoraReporte = (accion) => {
        if (accion === AccionBitacora.Generar) {
            let fecha_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let hora_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("HH:mm");
            let fecha_fin = dayjs(endDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let dataGrupos = (grupos || []).filter(w => (selectedGrupo || []).includes(w.value));
            let dataVehiculos = (vehiculos || []).filter(w => (selectedVehicle || []).includes(w.value));
            let dataAlertas = [];
            filtrosGenerarRef.current = { fecha_inicio, hora_inicio, fecha_fin, dataGrupos, dataVehiculos, dataAlertas };
        }
        guardarBitacora({
            categoria: 'Reporte Radar',
            observacion: generarObservacion(
                'Radar',
                {
                    fecha_inicio: filtrosGenerarRef.current.fecha_inicio,
                    hora_inicio: filtrosGenerarRef.current.hora_inicio,
                    fecha_fin: filtrosGenerarRef.current.fecha_fin,
                    grupos: filtrosGenerarRef.current.dataGrupos.map(w => w.label).join(', '),
                    vehiculos: filtrosGenerarRef.current.dataVehiculos.map(w => w.label).join(', '),
                    tipoAlertas: filtrosGenerarRef.current.dataAlertas.map(w => w.label).join(', '),
                }
            ),
            tipoAccion: accion
        });
    }
    // 📌 Método para manejar cualquier Select
    const handleSelectChange = (selected, options, setSelected) => {

        const allSelected = selected.some(option => option.value === 'all');

        const todasLasOpciones = options.flatMap(grupo => grupo.options || grupo);

        if (allSelected) {
            if (selected.length === todasLasOpciones.length + 1) { // 🔹 Se suma 1 por la opción "Seleccionar todos"
                setSelected([]); // 🔹 Deseleccionar todo correctamente
            } else {
                setSelected(todasLasOpciones); // 🔹 Seleccionar todas las opciones ignorando los agrupadores
            }
        } else {
            setSelected(selected);
        }
    };

    // 📌 Personalizar la vista del Select
    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '34px',
            overflow: 'hidden'
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: '34px',
            overflow: 'hidden'
        })
    };

    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className="position-relative">
            <Form.Control ref={ref} onClick={onClick} value={value} onChange={() => { }} />
        </div>
    ));

    const handleFieldChange = (e) => {
        const { value } = e.target;
        console.log(value);
        setDistancia(value);
    };

    // Handle functions for DatePicker onChange and custom header
    const handleStartDateChangeWrapper = useCallback((date) => {
        handleStartDateChange(date, startDate, endDate, setStartDate, setEndDate);
    }, [startDate, endDate]);
    const handleEndDateChangeWrapper = useCallback((date) => {
        handleEndDateChange(date, startDate, endDate, setStartDate, setEndDate);
    }, [startDate, endDate]);

    const renderIniHeader = useMemo(
        () => (props) => createRenderCustomHeader(startDate, handleStartDateChangeWrapper)(props),
        [startDate, handleStartDateChangeWrapper]
    );
    const renderEndHeader = useMemo(
        () => (props) => createRenderCustomHeader(endDate, handleEndDateChangeWrapper)(props),
        [endDate, handleEndDateChangeWrapper]
    );

    useEffect(() => {
        if (store.map === null) return;
        try {
            const placeAutocomplete = new google.maps.places.PlaceAutocompleteElement();
            placeAutocomplete.id = 'place-autocomplete-card';
            const card = document.getElementById('place-autocomplete-group');
            card.appendChild(placeAutocomplete);
            placeAutocomplete.addEventListener('gmp-select', async ({ placePrediction }) => {
                const place = placePrediction.toPlace();
                await place.fetchFields({ fields: ['displayName', 'formattedAddress', 'location'] });
                if (place && place.location) {
                    const lat = place.location.lat();
                    const lng = place.location.lng();
                    actualizarMiUbicacion({ lat, lng, zoomLevel: 14 });
                } else {
                    console.warn("Lugar inválido o sin geometría");
                }
            });
        } catch { }
    }, [store]);

    if (!isLoaded) return <div>Loading...</div>;

    return (
        <div>
            <div id="filter-collapse">
                <Row className='mb-3'>
                    {dateRangeWarning && (
                        <Col xs={12}>
                            <div className="alert alert-warning py-2 my-2">
                                {dateRangeWarning}
                            </div>
                        </Col>
                    )}


                    <Col md={3} xs={4}>
                        <Form.Group>
                            <Form.Label>Desde</Form.Label>
                            <DatePicker
                                selected={startDate}
                                onChange={handleStartDateChangeWrapper}
                                customInput={<ExampleCustomInput />}
                                timeIntervals={5}
                                dateFormat="dd/MM/yyyy HH:mm:ss"
                                /* showTimeSelect */
                                renderCustomHeader={renderIniHeader}
                                popperClassName="custom-datepicker-popper"
                                fixedHeight
                                locale="es"
                                timeCaption="Hora"
                                maxDate={new Date()}
                                minTime={new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0)}
                                maxTime={
                                    (startDate.getDate() === now.getDate() && startDate.getMonth() === now.getMonth() && startDate.getFullYear() === now.getFullYear())
                                        ? now
                                        : new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 23, 59, 59)
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3} xs={4}>
                        <Form.Group>
                            <Form.Label>Hasta</Form.Label>
                            <DatePicker
                                selected={endDate}
                                minDate={startDate}
                                minTime={
                                    endDate.getDate() === startDate.getDate() && endDate.getMonth() === startDate.getMonth() && endDate.getFullYear() === startDate.getFullYear()
                                        ? startDate
                                        : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0)
                                }
                                maxTime={
                                    (endDate.getDate() === now.getDate() && endDate.getMonth() === now.getMonth() && endDate.getFullYear() === now.getFullYear())
                                        ? now
                                        : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59)
                                }
                                onChange={handleEndDateChangeWrapper}
                                customInput={<ExampleCustomInput />}
                                timeIntervals={5}
                                dateFormat="dd/MM/yyyy HH:mm:ss"
                                /* showTimeSelect */
                                renderCustomHeader={renderEndHeader}
                                popperClassName="custom-datepicker-popper"
                                fixedHeight
                                locale="es"
                                timeCaption="Hora"
                                maxDate={new Date()}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3} xs={4} className="d-flex flex-column">
                        <label>Grupo</label>
                        <MultiSelect
                            className="multiselect-ul w-full md:w-20rem"
                            value={selectedGrupo}
                            onChange={(e) => {
                                setSelectedGrupo(e.value);
                                setSelectedVehicle([]);
                            }}
                            options={grupos}
                            optionLabel="label"
                            filter
                            placeholder="Seleccione un grupo"
                            maxSelectedLabels={2}
                            selectedItemsLabel={`${(selectedGrupo || []).length} grupos seleccionados`}
                        />
                    </Col>
                    <Col md={3} xs={4} className="d-flex flex-column">
                        <label>Vehículos</label>
                        <MultiSelect
                            className="multiselect-ul w-full md:w-20rem"
                            value={selectedVehicle}
                            onChange={(e) => {
                                setSelectedVehicle(e.value);
                            }}
                            options={vehiculosFiltrado}
                            optionLabel="label"
                            filter
                            placeholder="Seleccione un vehículo"
                            maxSelectedLabels={2}
                            selectedItemsLabel={`${(selectedVehicle || []).length} vehículos seleccionados`}
                        />
                    </Col>

                    {/**
                     * <Col md={3} xs={4}>
                        <Form.Group>
                            <Form.Label>Grupos</Form.Label>
                            <Select
                                key={'group-selector'}
                                closeMenuOnSelect={false}
                                options={[...grupos]}
                                classNamePrefix="react-select"
                                placeholder='Seleccionar...'
                                isClearable="true"
                                value={selectedGrupos}
                                onChange={(selected) => setSelectedGrupos(selected)}
                                styles={customStyles}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3} xs={4}>
                        <Form.Group>
                            <Form.Label>Vehículos</Form.Label>
                            <Select
                                key={'vehicle-selector'}
                                closeMenuOnSelect={false}
                                options={[
                                    ...(selectedVehiculos.length !== vehiculosFiltrados.length
                                        ? [{ value: 'all', label: 'Seleccionar todos' }]
                                        : [{ value: 'all', label: 'Deseleccionar todos' }]
                                    ),
                                    ...vehiculosFiltrados
                                ]}
                                classNamePrefix="react-select"
                                placeholder='Seleccionar...'
                                value={selectedVehiculos}
                                onChange={(selected) => handleSelectChange(selected, vehiculosFiltrados, setSelectedVehiculos)}
                                isMulti
                                styles={customStyles}
                            />
                        </Form.Group>
                    </Col>
                     */}

                </Row>

                <Row>
                    <Col md={3} xs={4}>
                        <Form.Group>
                            <Form.Label>Distancia (metros)</Form.Label>
                            <Form.Control
                                placeholder="0"
                                value={distancia}
                                name="distancia"
                                onChange={(e) => {
                                    const value = Number(e.target.value);
                                    if (value <= 500 && value >= 0) {
                                        handleFieldChange(e);
                                    }
                                }}
                                type="number"
                                maxLength={3}
                                min={0}
                                max={500}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3} xs={4}>
                        <Form.Label>Dirección</Form.Label>
                        <div id="place-autocomplete-group"></div>
                    </Col>
                    {/*<Form.Control
                            id='pac-input'
                            placeholder={"Introduce una ubicación"}
                            type="text"
                        />
                    <Col md={3} xs={4}>
                        <Form.Group>
                            <Form.Label>Dirección</Form.Label>
                            <ReactGoogleAutocomplete
                                apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                                className="form-control"
                                onPlaceSelected={(place) => {
                                    try {
                                        const latt = place.geometry.location.lat();
                                        const lngg = place.geometry.location.lng();
                                        actualizarMiUbicacion({ lat: latt, lng: lngg, zoomLevel: 14 });
                                    } catch (error) {

                                    }
                                }}
                                options={{
                                    types: [],
                                }}
                            />
                        </Form.Group>
                    </Col>*/}
                    <Col md={2} xs={4}>
                        <div className="d-flex mt-4">
                            <Button variant="primary" className='w-100' onClick={handleGenerate} disabled={!btnFiltroActivo || dateRangeInvalid}>
                                Generar
                            </Button>
                            {/* {dateRangeWarning && (
                                <div style={{ color: 'red', fontSize: 13, marginTop: 4 }}>{dateRangeWarning}</div>
                            )} */}
                        </div>
                    </Col>

                    <Col md={2} xs={4}>
                        <div className="print-report d-flex mt-4" style={(imprimir || false) ? {} : { pointerEvents: 'none', opacity: 0.5 }}>
                        </div>
                    </Col>
                </Row>
            </div>
            {/* </Collapse> */}
        </div>
    );
};

export default PuntoCercanoFiltros;